import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import CompanyHighlights from "./components/CompanyHighlights";
import BusinessFlow from "./components/BusinessFlow";
import ProductCatalog from "./components/ProductCatalog";
import InternationalSection from "./components/InternationalSection";
import Principles from "./components/Principles";
import Closing from "./components/Closing";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Preloader from "@/components/base/Preloader";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Preloader />
      <Header />
      <main>
        <Hero />
        <About />
        <CompanyHighlights />
        <BusinessFlow />
        <ProductCatalog />
        <InternationalSection />
        <Principles />
        <Closing />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}